import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ISessionResponse } from './single-sign-on.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionTokenService } from '../../service/session-token';
import { TimezoneStorage } from '../../../shared/misc/service/timezone-storage';
import { DeviceFingerprintService } from '../../service/device-fingerprint-service';

@Component({
    selector: 'session-single-sign-on',
    templateUrl: './single-sign-on.component.html',
    styleUrls: ['./single-sign-on.component.scss'],
})
export class SingleSignOnComponent implements OnInit {
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private route: ActivatedRoute,
        protected sessionService: SessionTokenService,
        protected deviceFingerprintService: DeviceFingerprintService
    ) {}

    ngOnInit() {
        if (!this.route.snapshot.queryParams.t) {
            this.router.navigate(['/login']);
            return;
        }

        this.httpClient.post('/session/token', { token: this.route.snapshot.queryParams.t }).subscribe(
            (result: ISessionResponse) => this.onSubmit(result),
            (err) => {
                this.router.navigate(['/login']);
            }
        );
    }

    onSubmit(result: ISessionResponse): void {
        TimezoneStorage.store(result.timezone);
        this.sessionService.persistWithExpiry(result, result.expiresIn);
        this.sessionService.persistSSOSession();

        if (result.role === 'ADMIN') {
            this.router.navigate(['/admin/accounts']);
            return;
        }
        this.router.navigate(['/campaign']);
    }
}
